import IUserPropertyEntity from "../../interfaces/iuser_property_entity.type";

export default class UserPropertyEntity {
   private readonly studentAge: string | undefined;
   private readonly mixpanelId: string | undefined;
   private readonly jobTitle: string | undefined;
   private readonly lastViewedLatestFeatures: string | undefined;
   private readonly showFillInTheBlankIntro: string | undefined;
   private readonly sessionViewShowWork: string | undefined;
   private readonly helpDialogsViewed: string | undefined;
   private readonly showMcIntro: string | undefined;
   private readonly showSessionRefactorDialog: string | undefined;
   private readonly migration: string | undefined;
   constructor(
      userIndividualProperties: IUserPropertyEntity
   ) {
      this.studentAge = userIndividualProperties.student_age;
      this.mixpanelId = userIndividualProperties.mixpanel_id;
      this.jobTitle = userIndividualProperties.job_title;
      this.lastViewedLatestFeatures = userIndividualProperties.last_viewed_latest_features;
      this.showFillInTheBlankIntro = userIndividualProperties.show_fill_in_the_blank_intro;
      this.sessionViewShowWork = userIndividualProperties.session_view_show_work;
      this.helpDialogsViewed = userIndividualProperties.help_dialogs_viewed;
      this.showMcIntro = userIndividualProperties.show_mc_intro;
      this.showSessionRefactorDialog = userIndividualProperties.show_session_refactor_dialog;
      this.migration = userIndividualProperties.migration;
   }
   getStudentAge = () => this.studentAge;
   getMixpanelId = () => this.mixpanelId;
   getJobTitle = () => this.jobTitle;
   getLastViewedLatestFeatures = () => this.lastViewedLatestFeatures;
   getShowFillInTheBlankIntro = () => this.showFillInTheBlankIntro;
   getSessionViewShowWork = () => this.sessionViewShowWork;
   getHelpDialogsViewed = () => this.helpDialogsViewed;
   getShowMcIntro = () => this.showMcIntro;
   getShowSessionRefactorDialog = () => this.showSessionRefactorDialog;
   getMigration = () => this.migration;
   toObject = () => ({
      studentAge: this.getStudentAge(),
      mixpanelId: this.getMixpanelId(),
      jobTitle: this.getJobTitle(),
      lastViewedLatestFeatures: this.getLastViewedLatestFeatures(),
      showFillInTheBlankIntro: this.getShowFillInTheBlankIntro(),
      sessionViewShowWork: this.getSessionViewShowWork(),
      helpDialogsViewed: this.getHelpDialogsViewed(),
      showMcIntro: this.getShowMcIntro(),
      showSessionRefactorDialog: this.getShowSessionRefactorDialog(),
      migration: this.getMigration()
   });
}
